export default __webpack_public_path__ + "static/media/logo-footer.63d537d7.gif";